import { inject, Injectable } from '@angular/core';
import { Departures } from 'app/core/enums/common.enum';
import { CnNvSalesEndpoints } from 'app/core/enums/endpoints';
import { DeleteSaleBody } from 'app/core/interfaces/finances';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConcessionNoveltiesSalesService {
    private _endpoint = CnNvSalesEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // -----------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------
    // -----------------------------------------------------------------------------
    // @ CRUD methods
    // -----------------------------------------------------------------------------

    getAll(
        playdateId: number,
        departure: Departures,
        params?: {
            locationId?: number;
            categoryId?: number;
            subcategoryId?: number;
            productId?: number;
        }
    ): Observable<any> {
        // location_id
        // category_id
        // subcategory_id
        // product_id

        return this._apiService.getOne(
            `${this._endpoint.getAllItemsSold}/${departure}`,
            playdateId
        );
    }

    // getOne(id: number): Observable<any> {
    //     return this._apiService.getOne(this._endpoint.getOne, id);
    // }

    create(data: any): Observable<any> {
        return this._apiService.post(this._endpoint.create, data);
    }

    update(data: string, id: number): Observable<any> {
        return this._apiService.update(this._endpoint.update, data, id);
    }

    delete(data: DeleteSaleBody): Observable<any> {
        return this._apiService.deleteWithParam(this._endpoint.delete, data);
    }
}
